import { SupportTicket } from "../types/SupportTicket";
import { doDelete, doGet, doPost, doPut } from "./http.service";
import { Page } from "../types/Page";

export interface SupportTicketFilter {
    page: number;
    size: number;
    sortKey: string;
    sortOrder: "asc" | "desc";
    title?: string;
    content?: string;
}

export function createTicket(ticket: Partial<SupportTicket>) {
    return doPost<SupportTicket>("/support-tickets", ticket);
}

export function updateStatus(id:string, payload: {status: "OPEN" | "CLOSED"}) {
    return doPut<SupportTicket>("/support-tickets/" + id + "/status", payload);
}

export function loadTicketsPage(filter:SupportTicketFilter) {
    return doGet<Page<SupportTicket>>("/support-tickets", {params: filter});
}
export function loadTicketsByParent(id: string) {
    return doGet<SupportTicket[]>("/support-tickets/" + id);
}

export function deleteTicket(id: string) {
    return doDelete("/support-tickets/" + id);
}
export function requireAttentionAsAdmin() {
    return doGet<void>("/support-tickets/require-attention-admin");
}
export function requireAttentionAsUser() {
    return doGet<void>("/support-tickets/require-attention-me");
}